module.exports = __webpack_public_path__ + "assets/img/tx11gt.105559fc.jpg";